import { useRef, useState, type FC } from "react";
import SideNav from "../nav/SideNav";
import Divider from "@mui/material/Divider";
import AdsComponent from "../AdsComponent";
import { ComponentBaseContainer, ComponentContainer, JsonContainer, JsonHelperContainer, JsonTextContainer, StyledClearIcon, StyledCopyIcon } from "../jsonformatter/JsonFormatter.style";
import { Helmet } from "react-helmet-async";
const Base64Tool: FC = () => {
  const [output, setOutput] = useState<string>('');
  const [showToast, setShowToast] = useState(false);
  const editorRef = useRef<any>(null);
  const outputRef = useRef<any>(null);

  function isProbablyBase64(str: string): boolean {
    if (!str || str.length < 8 || str.length % 4 !== 0) return false;

    const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;
    if (!base64Regex.test(str)) return false;

    try {
      const binaryStr = atob(str);
      const bytes = Uint8Array.from(binaryStr, c => c.charCodeAt(0));
      const decoded = new TextDecoder().decode(bytes);

      // Check: At least 80% of decoded characters should be printable (ASCII range 32–126)
      const printable = decoded.split('').filter(c => c.charCodeAt(0) >= 32 && c.charCodeAt(0) <= 126).length;
      const ratio = printable / decoded.length;

      return ratio >= 0.8;
    } catch {
      return false;
    }
  }

  const handleInput = (value: string) => {
    try {
      if (isProbablyBase64(value)) {
        const decoded = atob(value);
        // If decoding doesn't throw, we assume it's Base64
        setOutput(decoded);
      } else {
        const encoded = btoa(value);
        setOutput(encoded);

      }
    } catch {


    }
  };

  const handleClear = () => {
    editorRef.current?.editor?.setValue("", -1);
    setOutput('');
  };

  const handleCopy = () => {
    const content = outputRef.current?.editor?.getValue();
    content && navigator.clipboard.writeText(content)
      .then(() => {
        setShowToast(true);
        setTimeout(() => setShowToast(false), 1000);
      });
  };

  return (
    <ComponentBaseContainer>
      <Helmet>
        <title>Base64 Encoder & Decoder | Online Text Converter</title>
        <meta name="description" content="Encode or decode Base64 text online. Simple and fast Base64 converter for developers and security tools." />
        <meta name="keywords" content="base64 encoder, base64 decoder, online base64 tool, encode text, decode base64" />
      </Helmet>

      <SideNav />
      <ComponentContainer>
        <JsonContainer>
          <JsonHelperContainer onClick={handleClear}>
            <StyledClearIcon />
          </JsonHelperContainer>
          <Divider />
          <JsonTextContainer
            placeholder="Paste Base64 or plain text here..."
            mode="text"
            ref={editorRef}
            name="base64-editor"
            wrapEnabled
            onChange={handleInput}
            setOptions={{
              useWorker: false,
              showLineNumbers: true,
              tabSize: 2,
            }}
          />
          {/* <>
            <input
              type="file"
              ref={inputRef}
              onChange={handleImageUpload}
              style={{ display: 'none' }}
            />
            <Fab
              variant="extended"
              onClick={handleClick}
              style={{zIndex:"99", position:"absolute", bottom:"10"}}
            >
              <UploadFileIcon sx={{ mr: 1 }} />
              Upload File
            </Fab>
          </> */}
        </JsonContainer>
        <Divider orientation="vertical" />
        <JsonContainer>
          <JsonHelperContainer onClick={handleCopy}>
            <StyledCopyIcon />
          </JsonHelperContainer>
          <Divider />
          <JsonTextContainer
            placeholder="Your output will appear here..."
            mode="text"
            ref={outputRef}
            name="base64-output"
            value={output}
            wrapEnabled
            readOnly
            setOptions={{
              useWorker: false,
              showLineNumbers: true,
              tabSize: 2,
            }}
          />
        </JsonContainer>
      </ComponentContainer>
      {showToast && (
        <div style={{
          position: "absolute",
          top: "10px",
          left: "50%",
          transform: "translateX(-50%)",
          background: "#323232",
          color: "white",
          padding: "8px 16px",
          borderRadius: "6px",
          opacity: 0.9,
          fontSize: "14px",
        }}>
          Copied to clipboard!
        </div>
      )}
      <AdsComponent />
    </ComponentBaseContainer>
  );
};

export default Base64Tool;
